import { colors, DATE_WITH_TIME_FORMAT } from '@utils/constants';
import dayjs from 'dayjs';
import { NumericArrayParam, StringParam, withDefault } from 'use-query-params';

export const taskStatuses = ['Otib_ketgan', 'Bugungi', 'Ertangi', 'Rejada'];
export const taskActionStatuses = ['delete', 'lastMonday', 'lastMonth', 'done'];

export const taskStatusColors: Record<string, string> = {
  Otib_ketgan: colors.error[500],
  Bugungi: colors.warning[500],
  Ertangi: colors.progress[500],
  Rejada: colors.violet[500]
};

export const taskDroppableColors: Record<string, string> = {
  Otib_ketgan: colors.error[100],
  Bugungi: colors.warning[100],
  Ertangi: colors.progress[100],
  Rejada: colors.violet[100]
};

export const taskQueryValues = {
  startDate: StringParam,
  finishDate: StringParam,
  leadTaskTypeIds: NumericArrayParam,
  pipeStatusIds: NumericArrayParam,
  employeeList: withDefault(NumericArrayParam, null),
  // employeeList: NumericArrayParam,
  leadTaskStatusFilter: StringParam,
  createdByIds: NumericArrayParam,
  leadTaskTypeFilter: StringParam
};

export const assigns: Record<
  string,
  {
    startDate: string | null;
    finishDate: string | null;
  }
> = {
  Otib_ketgan: {
    startDate: null,
    finishDate: dayjs().add(-1, 'day').hour(23).minute(59).format(DATE_WITH_TIME_FORMAT)
  },
  Bugungi: {
    startDate: dayjs().hour(0).minute(0).format(DATE_WITH_TIME_FORMAT),
    finishDate: dayjs().hour(23).minute(59).format(DATE_WITH_TIME_FORMAT)
  },
  Ertangi: {
    startDate: dayjs().add(1, 'day').hour(0).minute(0).format(DATE_WITH_TIME_FORMAT),
    finishDate: dayjs().add(1, 'day').hour(23).minute(59).format(DATE_WITH_TIME_FORMAT)
  },
  Rejada: {
    startDate: dayjs().add(2, 'day').hour(0).minute(0).format(DATE_WITH_TIME_FORMAT),
    finishDate: null
  }
};

export const queryKeys = {
  TASKS: 'all-kanban-tasks'
};
